export default __webpack_public_path__ + "static/media/Disconnected.b53cfd7e.svg";